import React, { useState, useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

// MDI
import Icon from '@mdi/react';
import { mdiVolumeHigh } from '@mdi/js';

// Actions
import * as AudioActions from 'store/ducks/audio/actions';

// Types
import { ApplicationState } from 'store';

// Styles
import useStyles, { CircularProgress } from './StopDrawer.styles';

interface StopDrawerInterface {
  title: string;
  stopId: string;
  classes?: {
    root?: string;
    header?: string;
    title?: string;
  };
  body: React.ReactNode | React.ReactElement;
  footer: React.ReactNode | React.ReactElement;
}

type Props = StopDrawerInterface;

const StopDrawer: React.FC<Props> = ({
  title,
  stopId,
  classes: customClasses,
  body,
  footer,
}) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const audioLink = useSelector(
    (state: ApplicationState) => state.audio.audioLink,
  );

  const audioLoading = useSelector(
    (state: ApplicationState) => state.audio.loading,
  );

  const [hasAudio, setHasAudio] = useState(false);

  useEffect(() => {
    if (hasAudio && audioLink) {
      new Audio(audioLink).play();
    }
  }, [hasAudio, audioLink]);

  useEffect(
    () =>
      // Unmount
      () => {
        setHasAudio(false);
      },
    [],
  );

  return (
    <div className={[classes.root, customClasses?.root].join(' ')}>
      <Box display='flex' flexDirection='column' width='100%'>
        <Box flexGrow={0} p={2} className={customClasses?.header}>
          <Box display='flex' alignItems='center'>
            <Typography
              className={[classes.title, customClasses?.title].join(' ')}
              variant='h6'>
              {title}
            </Typography>

            {audioLoading ? (
              <Box
                display='flex'
                justifyContent='center'
                alignItems='center'
                width={50}
                height={50}>
                <CircularProgress size={20} />
              </Box>
            ) : (
              <IconButton
                onClick={() => {
                  dispatch(
                    AudioActions.getAudioRequest({
                      stopId,
                    }),
                  );

                  setHasAudio(true);
                }}>
                <Tooltip placement='top' title='Ouvir nome do ponto' arrow>
                  <Icon path={mdiVolumeHigh} size={1.1} />
                </Tooltip>
              </IconButton>
            )}
          </Box>
        </Box>

        {/* Body */}
        <>{body}</>

        {/* Footer */}
        <>{footer}</>
      </Box>
    </div>
  );
};

export default StopDrawer;
export { StopDrawer };
